import * as React from "react";

const Loading = () => (
    <div className="loading active"><div>
        <div className="loader">Caricamento...</div>
    </div></div>
)
export default Loading;



// WEBPACK FOOTER //
// ./src/components/ui/Loading.tsx